import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../../constants/common'
import { useContentOverflow } from '../../../../../../hooks'
import { Avatar, AVATAR_HEIGHT_32 } from '../../../../../Avatar'
import { FloatingTooltip } from '../../../../../Floating'
import { getRentalPortalApplicantIdentityLabel } from '../../../../../RentalPortalApplicant'
import Text from '../../../../../Text'
import { useApplicantProfileContext } from '../../../RentalPortalApplicantProfile.hooks'
import { getApplicantIdentityAvatarProps } from '../../ApplicantIdentityWidget'
import { ApplicantDecisionActions } from '../ApplicantDecisionActions'
import {
  QA_NAME_APPLICANT_DECISION_APPLICANT,
  QA_NAME_APPLICANT_DECISION_APPLICANT_AVATAR,
} from '../ApplicantDecisionPanel.constants'
import { getApplicantDecisionSelectActions } from '../ApplicantDecisionPanel.utils.actions'

import * as styles from './ApplicantDecisionApplicant.module.css'

function ApplicantDecisionApplicant({ onClickAction }) {
  const { t } = useTranslation()

  const { applicantData, isPreview } = useApplicantProfileContext()

  const { overflow, setContentOverflowRef } = useContentOverflow()

  const applicantLabel = getRentalPortalApplicantIdentityLabel({
    applicant: applicantData,
    t,
  })

  return (
    <div className={styles.ApplicantDecisionApplicant}>
      <Avatar
        {...getApplicantIdentityAvatarProps(applicantData)}
        qaName={QA_NAME_APPLICANT_DECISION_APPLICANT_AVATAR}
        size={AVATAR_HEIGHT_32}
      />
      <FloatingTooltip
        content={applicantLabel}
        disabled={!overflow}
        placement={FLOATING_ELEMENT_PLACEMENT.top}
      >
        <Text
          className={styles.name}
          qaName={QA_NAME_APPLICANT_DECISION_APPLICANT}
          ref={setContentOverflowRef}
        >
          {applicantLabel}
        </Text>
      </FloatingTooltip>
      <ApplicantDecisionActions
        actions={getApplicantDecisionSelectActions({
          applicantData,
          isPreview,
          t,
        })}
        className={styles.actions}
        onClick={onClickAction}
      />
    </div>
  )
}

export default ApplicantDecisionApplicant
